export default ({ pgaFlag, processingCode, programCode }) => {
  return (
    ['FD3', 'FD4'].includes(pgaFlag) &&
    programCode === 'FOO' &&
    processingCode !== 'CCW'
  );
};
// TODO In the codes object, we list these tags as applying to all programCodes. I believe this to be false and they are only relevant to FOO. I also believet that CCW is exempt
